import { IApplicationState } from '@store'

export const selectXMetricsSummary = (state: IApplicationState, campaignId: number) => {
  return state.reportings.xMetrics.xMetricsSummaryByCampaignId[campaignId] ?? {}
}

export const selectXMetricIds = (state: IApplicationState, campaignId: number) =>
  state.reportings.xMetrics.xMetricIdsByCampaignId[campaignId] ?? []

export const selectXMetrics = (state: IApplicationState, id: number) =>
  state.reportings.xMetrics.xMetricsById[id] ?? {}
